import { Component } from '@angular/core';
import { ContentCardComponent } from 'app/common/components/content-card/content-card.component';
import { LinksComponent } from 'app/common/components/links/links.component';
import { AboutTicketsComponent } from './components/about-tickets/about-tickets.component';
import { ChipComponent } from 'app/common/components/chip/chip.component';
import { FooterComponent } from 'app/footer/footer.component';
import { TicketComponent } from './components/ticket/ticket.component';
import { BackButtonComponent } from 'app/common/components/back-button/back-button.component';

@Component({
  selector: 'app-nvt-tickets',
  templateUrl: './nvt-tickets.component.html',
  styleUrls: ['./nvt-tickets.component.less'],
  imports: [
    ContentCardComponent,
    LinksComponent,
    AboutTicketsComponent,
    ChipComponent,
    FooterComponent,
    TicketComponent,
    BackButtonComponent,
  ],
})
export class NvtTicketsComponent {
  Instagram = 'https://www.instagram.com/neuburgervolkstheater/';
  Facebook = 'https://www.facebook.com/VolkstheaterNeuburg';
  Web = 'https://nvt-tickets.de';
  Color = '#A13333';

  chips = ['Wordpress', 'Tickera', 'ECommerce'];
}
